import React from 'react';
import Layout from '../components/Layout';
import ShippingMethodList from '../components/ShippingMethodList';

const ShippingMethods = () => {
  return (
    <Layout>
      <ShippingMethodList />
    </Layout>
  );
};

export default ShippingMethods;
